import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

export const GetAnrNbrTrackingLastUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Validation/GetAnrNbrTrackingLastUpdate`,
	params: {}
});

export const GetAnrNbrTrackingSitesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Validation/GetAnrNbrTrackingSites`,
	params: {}
});

export const GetAnrNbrTrackingTableRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Validation/GetAnrNbrTrackingOverview`,
	params: {}
});

export const GetAnrNbrTrackingExportRequest = (sites, startDate, endDate) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Validation/GetAnrNbrTrackingExport`,
	params: { sites, startDate, endDate }
});
